import React from 'react';

import { connect } from 'react-redux';

import { Select } from '@nerdwallet/currency';

import { HOME_AFFORDABILITY } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import { inputsSelector } from '../../../lib/selectors/home-affordability-calculator-selectors';
import {
  HomeAffordabilityInput,
  INPUT_TRACKING_TYPES,
  inputOnChange,
} from '../../../lib/utils';
import {
  VETERAN_TYPE_MILITARY_OPTION,
  VETERAN_TYPE_NATIONAL_GUARD_OPTION,
  veteranOptions as VeteranDropdownOptions,
} from '../hacControlOptions';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

export const getAnalyticValue = (value: string): string => {
  switch (value) {
    case VETERAN_TYPE_MILITARY_OPTION.value:
      return 'yes_regular';
    case VETERAN_TYPE_NATIONAL_GUARD_OPTION.value:
      return 'yes_national_guard';
    default:
      return 'no';
  }
};

const VeteranEligibilityInput: React.FC<HomeAffordabilityInput> = ({
  inputs,
  dispatch,
  analytics,
  validations,
  label = '',
  className = '',
  tooltip = '',
  fullWidth,
}) => {
  const value = inputs?.veteranType;
  const errorMessage = validations?.veteranType?.[0];
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'veteranType',
        inputType: INPUT_TRACKING_TYPES.RANGE,
      };
    }

    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_s',
      };
    }
    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'veteranType',
      calculator: HOME_AFFORDABILITY,
      analyticValue: getAnalyticValue(e?.target?.value),
    });
  };

  return (
    <Select
      options={VeteranDropdownOptions}
      value={value}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      label={label}
      className={className}
      tooltip={tooltip}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state) => ({
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(VeteranEligibilityInput);
